import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { ProductLeadPopupComponent } from "app/products/product-lead-popup/product-lead-popup.component";
import { ActivatedRoute } from "@angular/router";


@Component({
  selector: 'app-product-home',
  templateUrl: './product-home.component.html',
  styleUrls: ['./product-home.component.css']
})
export class ProductHomeComponent implements OnInit {
  subCategories: any;
  pageData;
  page;
  products;
  questions;


  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    let data = this.route.snapshot.data['productData'];
    this.pageData = data.pageInfo.pageInfo;
    this.page = data.pageInfo.page;
    this.questions=data.pageInfo.questions;
    this.products=data.products.products;
    this.subCategories= data.products.filterCategory
  }


  openThisOffer(product){
    localStorage.setItem('choosen_product',JSON.stringify(product));
    localStorage.setItem('page-questions',JSON.stringify(this.questions));
    const modalRef = this.modalService.open(ProductLeadPopupComponent,{ size: 'lg',windowClass:'loan-lead-pop-up' });
  }

}



// WEBPACK FOOTER //
// ./src/app/products/product-home/product-home.component.ts